const EMPTY = Object.freeze({});

class ProductConfigModel {
    constructor (data = EMPTY) {
        const {
            fieldViewVenues,
            fieldVisionVenues,
            fieldVisionODDisablePriorToDate,
            context: {
                appContext,
                configs
            } = EMPTY
        } = data;

        // Copy the reponse data as-is
        // Prototype should take care of missing/uninitialized values.
        Object.assign(this, data);

        this.fieldVisionVenues = new Set(fieldVisionVenues);
        this.fieldViewVenues = new Set(fieldViewVenues);
        this.fieldVisionODDisablePriorToDate = fieldVisionODDisablePriorToDate;
        const { playerOfTheGameGameTypes } = configs?.[appContext] || {};
        this.potgGameTypes = new Set(playerOfTheGameGameTypes);
    }

    absConfig = EMPTY;
    adRefreshRate;
    appContext;
    context = EMPTY;
    currentSeason;
    defaultStadium;
    DFVSyncThresholdAhead = 2;
    DFVSyncThresholdBehind = 2;
    dictionary = EMPTY;
    disableDynamicFieldView;
    disableDynamicFieldViewDesktop;
    disableDynamicFieldViewMobile;
    disableDynamicUniforms;
    disableFieldVision;
    disableFieldVisionBat;
    disableFieldVisionOD;
    disablePlayerLinks;
    disableWebSockets;
    enableSummaryFiltersFinal = EMPTY;
    enableSummaryFiltersLive = EMPTY;
    enableTabsFinal = EMPTY;
    enableTabsLive = EMPTY;
    epgGameday = EMPTY;
    fieldViewVenues;
    fieldVisionLiveEntitlements;
    fieldVisionVenues;
    forceDefaultStadium;
    headerAlt;
    headerImg;
    headerUrl;
    internalName;
    leagueId;
    midInningAdConfig;
    name;
    promoInterstitial = [];
    season;
    seasonData = EMPTY;
    sid;
    sportId;
    teamId;
    teamNameDisplay;
    triCode;
    type;
    webSocketWindow;
    sportIds;
    leagueIds;
    fieldVisionLiveFreeGameOnly = true;
    potgGameTypes;
    dfvPlay = EMPTY;
}

export default ProductConfigModel;
